<template>
	<div class="home">
		<div class="h">
			<myheader></myheader>
			<mynav></mynav>
			<div class="main">
				<div class="fl" @mouseover="onin" @mouseleave="onout">
					<div :class="cshow ? 'category' : 'category hidden'">
						<div class="title">全部商品分类</div>
						<div class="cmain">
							<div class="citem" v-for="(v,k) in appdata.product_category_list" :key="k"
								@mouseover="oninitem(v)">
								<div class="icon">
									<img :src="v.icon">
								</div>
								<div class="spans">
									<span v-for="(x,y) in v.children" @click="onlist(x)">{{x.name}}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="cdetail" v-show="cshow">
						<div class="content">
							<div class="ditem" v-for="(v,k) in detaillist" :key="k">
								<div class="dtitle" @click="onlist(v)">{{v.name}}</div>
								<div class="divs">
									<div v-for="(x,y) in v.children" :key="y" @click="onlist(x)">
										{{x.name}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="carousel">
					<el-carousel height="416px">
						<el-carousel-item v-for="(v,k) in appdata.ad_list" :key="k">
							<img class="img" :src="v.pic" @click="onjump(v)">
						</el-carousel-item>
					</el-carousel>
				</div>

				<div class="ranking">
					<div class="title">
						<div>销量榜</div>
						<span @click="onlist('',1)">更多<i class="el-icon-arrow-right"></i></span>
					</div>
					<div class="rlist">
						<div class="ritem" v-for="(v,k) in rankingList" :key="k" @click="ondetail(v.id)">
							<div class="img">
								<img :src="onimgarr(v.pic)[0]" v-if="onimgarr(v.pic)[0]">
								<img v-else src="../assets/image/null.png">
							</div>
							<div class="text">
								<div class="name">{{v.cid_second}} {{v.style_number}}</div>
								<div class="xl">销量<span>{{v.buy_number_2week}}</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="commoditybox">
				<div class="commoditys">
					<div class="ctitle">猜你喜欢</div>
					<div class="clist">
						<div class="commodity" v-for="(v,k) in productList" :key="k" @click="ondetail(v.id)">
							<div class="img">
								<img :src="onimgarr(v.pic)[0]" v-if="onimgarr(v.pic)[0]">
								<img v-else src="../assets/image/null.png">
							</div>
							<div class="name">{{v.brand}} {{v.sex}} {{v.cid_second}} {{v.cid_third}} {{v.style_number}}
							</div>
							<div class="price">会员价<i>￥</i><span>{{v.discount_price}}</span>起</div>
						</div>
					</div>
					
					<div class="pagediv">
						<el-pagination
							v-if="isLoggedIn && total > 0"
							background
							layout="prev, pager, next, sizes, total, jumper"
							:page-sizes="[20, 30, 50]"
							:current-page.sync="page"
							:page-size="pageSize"
							:total="total"
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
						/>
						<el-button
							v-else-if="productList.length"
							class="refresh-batch-btn"
							:loading="productLoading"
							@click="onRefreshBatch"
						>
							换一批
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<myfooter></myfooter>
	</div>
</template>

<script>
	export default {
		name: 'Home',
		data() {
			return {
				cshow: false,
				detaillist: [],
				rankingList: [],
				productList: [],
				page: 1,
				pageSize: 20,
				total: 0,
				productLoading: false,
			}
		},

		inject: ['appdata', 'onimgarr'],

		computed: {
			isLoggedIn() {
				return !!this.$cookies.get('token')
			},
		},

		mounted() {
			//排行榜
			this.product();
			//商品列表-猜你喜欢（order_type: 5）
			this.onproductList();
		},

		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.onproductList();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onproductList();
			},
			
			product() {
				this.$axios.get('api/product/top').then(res => {
					if (res.data.code == 0) {
						this.rankingList = res.data.data.rank1;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onproductList() {
				var params = {
					order_type: 5,
					pic: 1,
					page: this.page,
					limit: this.pageSize
				};
				this.productLoading = true
				this.$axios.post('/api/product/list', params).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.productList = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				}).finally(() => {
					this.productLoading = false
				})
			},

			onRefreshBatch() {
				const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize))
				if (maxPage <= 1) {
					this.page = 1
				} else {
					let nextPage = this.page
					while (nextPage === this.page) {
						nextPage = Math.floor(Math.random() * maxPage) + 1
					}
					this.page = nextPage
				}
				this.onproductList()
			},

			onin() {
				this.cshow = true;
			},

			onout() {
				this.cshow = false;
			},

			oninitem(val) {
				this.detaillist = val.children;
			},

			onlist(val,n) {			
				if(n == 1) {
					this.$router.push({
						path: '/list',
						query: {
							search: "",
						    order: 1
						}
					})
				}else {
					this.$router.push({
						path: '/list',
						query: {
							search: "",
							category: val.name,
						}
					})
				}
			},
			
			ondetail(val) {
				const url = this.$router.resolve({
					path: '/detail',
					query: {
						id: val
					}
				});
				window.open(url.href, "_blank");
			},
			
			onjump(v) {
				if(v.url) {
					window.open(v.url, "_blank");
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.main {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		margin-top: 16px;
	}

	.h {
		min-height: calc(100vh - 60px);
	}

	.fl {
		position: relative;
		width: 256px;
		// height: 416px;
	}

	.title {
		color: #1f1f1f;
		font-weight: 600;
		line-height: 19px;
		padding: 14px 18px 8px 18px;
		font-size: 16px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		span {
			font-size: 12px;
			cursor: pointer;
		}
	}

	.category {
		// height: 100%;
		width: 256px;
		background-color: #fff;
		border: 1px solid #fff;
		border-radius: 10px;
		box-sizing: border-box;
		position: absolute;
		padding-bottom: 8px;

		.cmain {
			.citem {
				width: 100%;
				color: #333;
				cursor: pointer;
				font-size: 14px;
				padding: 8px 18px;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				cursor: pointer;

				.icon {
					height: 20px;
					margin-right: 12px;
					width: 20px;
					min-width: 20px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.spans {
					white-space: nowrap;
					/* 确保文本不会换行 */
					overflow: hidden;
					/* 隐藏溢出的内容 */
					text-overflow: ellipsis;
					/* 显示省略符号来代表被修剪的文本 */

					span {
						position: relative;
					}

					span:hover {
						color: #ff4714;
					}

					span::after {
						content: "/";
						display: inline-block;
						margin: 0 5px;
					}

					span:hover::after {
						color: #333;
					}

					span:last-child::after {
						content: "";
						display: inline-block;
						margin: 0;
					}
				}
			}

			.citem:hover {
				background-color: #f5f5f5;
			}
		}
	}

	.hidden {
		overflow: hidden;
		height: 416px;
	}

	.cdetail {
		position: absolute;
		height: 493px;
		left: 100%;
		padding-left: 16px;
		position: absolute;
		top: -1px;
		width: 672px;
		z-index: 100;

		.content {
			border: 1px solid #ff4714;
			border-radius: 10px;
			height: 100%;
			overflow-y: auto;
			padding: 14px 20px 14px 30px;
			background-color: #fff;
			box-sizing: border-box;

			.ditem {
				padding-bottom: 20px;

				.dtitle {
					color: #111;
					cursor: pointer;
					font-size: 16px;
					position: relative;
					line-height: 20px;
					font-weight: bolder;
				}

				.dtitle:hover {
					color: #ff4714;
				}

				.dtitle::before {
					background-color: #ff4714;
					content: "";
					height: 80%;
					left: -10px;
					position: absolute;
					top: 10%;
					width: 3px;
				}


				.divs {
					display: flex;
					flex-wrap: wrap;

					div {
						cursor: pointer;
						font-size: 14px;
						margin-right: 40px;
						padding-top: 20px;
					}

					div:hover {
						color: #ff4714;
					}
				}
			}
		}
	}

	.carousel {
		width: 654px;
		height: 416px;
		border-radius: 10px;
		overflow: hidden;

		.img {
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}

	.ranking {
		width: 254px;
		height: 416px;
		background-color: #fff;
		border-radius: 10px;
		position: relative;
		box-sizing: border-box;

		.rlist {
			width: 100%;
			height: 355px;
			padding: 0 15px;
			box-sizing: border-box;
			overflow: auto;

			.ritem {
				display: flex;
				margin-bottom: 8px;
				background: linear-gradient(90deg, #fff, #f7f7f7);
				border-radius: 10px;
				cursor: pointer;
				padding: 8px 12px 8px 0;
				box-sizing: border-box;

				// border: 1px solid #f1f1f1;
				.img {
					min-width: 60px;
					margin-right: 10px;

					img {
						width: 60px;
						height: 60px;
					}
				}

				.text {
					display: flex;
					flex-direction: column;
					width: 100%;
					justify-content: space-between;

					.name {
						color: #333;
						margin-top: 8px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						/* 限制文本为2行 */
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: normal;
						/* 允许换行 */
					}

					.xl {
						align-self: flex-end;
						color: #999;
						font-size: 12px;
						line-height: 14px;
						display: flex;

						span {
							color: #ff4714;
							font-size: 20px;
							font-weight: 700;
							line-height: 10px;
							margin-left: 4px;
						}
					}
				}
			}

			.ritem:hover {
				background: linear-gradient(90deg, #fff, #ffede8);
			}
		}
	}

	.commoditybox {
		width: 100%;

		.commoditys {
			width: 1200px;
			margin: 0 auto;
			padding: 24px 0;

			.ctitle {
				color: #0f0f0f;
				font-size: 24px;
				font-weight: 700;
				line-height: 28px;
				margin-bottom: 16px;
			}

			.clist {
				width: 1200px;
				display: flex;
				flex-wrap: wrap;
				

				.commodity {
					width: 224px;
					height: 330px;
					box-sizing: border-box;
					background-color: #fff;
					border-radius: 10px;
					overflow: hidden;
					cursor: pointer;
					margin-bottom: 20px;
					margin-right: 20px;
					.img {
						width: 224px;
						height: 224px;
						margin-bottom: 8px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.name {
						display: -webkit-box;
						font-size: 15px;
						font-weight: 700;
						height: 44px;
						line-height: 22px;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						margin-bottom: 8px;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						padding: 0 8px;
						box-sizing: border-box;
					}

					.price {
						color: #999;
						font-size: 12px;
						line-height: 14px;
						vertical-align: text-bottom;
						padding: 0 8px;
						box-sizing: border-box;

						i {
							color: #ff0200;
						}

						span {
							color: #ff0200;
							font-size: 24px;
							line-height: .8;
						}
					}
				}

				.commodity:hover {
					transform: scale(1.01);

					.name {
						color: #ff4714;
					}
				}
				
				.commodity:nth-child(5n) {
					margin-right: 0;
				}
			}

			.pagediv {
				display: flex;
				justify-content: flex-start;
				padding-top: 8px;
			}

			.refresh-batch-btn {
				min-width: 120px;
				height: 40px;
				color: #ff4714;
				border-color: #ff4714;
				background: #fff;
				font-size: 14px;

				&:hover,
				&:focus {
					color: #fff;
					border-color: #ff4714;
					background: #ff4714;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home.vue